import { render, staticRenderFns } from "./SegmentedControl.vue?vue&type=template&id=5df17651"
import script from "./SegmentedControl.vue?vue&type=script&lang=js"
export * from "./SegmentedControl.vue?vue&type=script&lang=js"
import style0 from "./SegmentedControl.vue?vue&type=style&index=0&id=5df17651&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports